export const GA_MEASUREMENT_ID = "G-07FC545ERY";

const GA_COOKIE_NAMES = [
  "_ga",
  `_ga_${GA_MEASUREMENT_ID.replace(/^G-/, "")}`,
  "_gid",
  "_gat",
];

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

export function updateAnalyticsConsent(granted: boolean) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("consent", "update", {
    analytics_storage: granted ? "granted" : "denied",
  });
  if (!granted) clearGaCookies();
}

export function trackPageview(path: string) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.origin + path,
    page_title: document.title,
  });
}

function clearGaCookies() {
  const host = window.location.hostname;
  const domains = new Set<string>(["", host]);
  const parts = host.split(".");
  if (parts.length >= 2) domains.add(`.${parts.slice(-2).join(".")}`);
  for (const name of GA_COOKIE_NAMES) {
    for (const domain of domains) {
      const domainPart = domain ? `; domain=${domain}` : "";
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${domainPart}`;
    }
  }
}
